import React from "react";

// Soft dusty-rose bunny silhouette — symbol of gentleness and safety.
export function Bunny({ className = "" }) {
  return (
    <svg
      viewBox="0 0 320 380"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="bunnyGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#C99AA1" />
          <stop offset="100%" stopColor="#B47B84" />
        </linearGradient>
      </defs>
      {/* ears */}
      <path
        d="M112 150 C96 92 92 34 110 12 C128 -6 150 30 150 92 C150 120 140 142 128 152 Z"
        fill="url(#bunnyGrad)"
      />
      <path
        d="M208 150 C224 92 228 34 210 12 C192 -6 170 30 170 92 C170 120 180 142 192 152 Z"
        fill="url(#bunnyGrad)"
      />
      {/* inner ears */}
      <path d="M118 132 C108 96 108 52 118 36 C128 52 130 96 124 130 Z" fill="#FAF3F4" opacity="0.7" />
      <path d="M202 132 C212 96 212 52 202 36 C192 52 190 96 196 130 Z" fill="#FAF3F4" opacity="0.7" />
      {/* head + body */}
      <path
        d="M160 138 C214 138 250 176 250 232 C250 268 232 296 214 314 C238 330 250 346 246 360 C240 378 190 372 160 366 C130 372 80 378 74 360 C70 346 82 330 106 314 C88 296 70 268 70 232 C70 176 106 138 160 138 Z"
        fill="url(#bunnyGrad)"
      />
      {/* belly */}
      <ellipse cx="160" cy="290" rx="52" ry="62" fill="#FAF3F4" opacity="0.55" />
    </svg>
  );
}
